import type { Tour } from '../../types';

export const platformWelcomeTour: Tour = {
  id: 'platform-welcome',
  name: 'Platform Admin Welcome',
  description: 'Get started with OHCS platform administration',
  category: 'platform',
  showProgress: true,
  steps: [
    {
      id: 'platform-welcome-1',
      target: 'platform-header-logo',
      title: 'Welcome, Platform Administrator',
      content: 'You have access to the central administration console for the OHCS Records Management System. From here, you can manage all MDAs across the platform.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'platform-welcome-2',
      target: 'platform-sidebar',
      title: 'Admin Navigation',
      content: 'The sidebar provides quick access to all administrative functions: Dashboard, MDAs, Users, Configuration, and Analytics.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'platform-welcome-3',
      target: 'platform-sidebar-dashboard',
      title: 'Platform Dashboard',
      content: 'View platform-wide statistics, monitor MDA activity, and track system health from your dashboard.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'platform-welcome-4',
      target: 'platform-sidebar-mdas',
      title: 'MDA Management',
      content: 'Create, configure, and manage all Ministries, Departments, and Agencies. Each MDA operates in its own isolated environment.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'platform-welcome-5',
      target: 'platform-sidebar-config',
      title: 'System Configuration',
      content: 'Configure platform-wide settings including document types, classification levels, security policies, and integrations.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'platform-welcome-6',
      target: 'platform-sidebar-analytics',
      title: 'Analytics & Reports',
      content: 'Access comprehensive analytics across all MDAs: usage statistics, storage metrics, and compliance reports.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'platform-welcome-7',
      target: 'platform-header-user',
      title: 'Your Admin Account',
      content: 'Manage your platform admin profile and access security settings from here. Welcome to OHCS Administration!',
      position: 'bottom',
      spotlight: true,
      actionLabel: 'Get Started',
    },
  ],
};
